import {v4 as uuidv4} from 'uuid';

export const getDeviceUUID = () => {
  const existingUuid = localStorage.getItem('uuid');
  if (existingUuid) {
    return existingUuid;
  }

  const newUuid = uuidv4();

  localStorage.setItem('uuid', newUuid);
  return newUuid;
};
